import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppCompanyResolverGuard } from './app-company-resolver.guard';
import { AuthAdminGuard } from './core/auth/guard/auth-admin.guard';
import { AuthGuard } from './core/auth/guard/auth.guard';
import { AuthVoluntaryGuard } from './core/auth/guard/auth-voluntary.guard';
import { AuthRegionalGuard } from './core/auth/guard/auth-regional.guard';
import { AuthCooperativeGuard } from './core/auth/guard/auth-cooperative.guard';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { environment } from 'src/environments/environment';

const applicationRoutes: Routes = [
  // ACCESS
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },

  {
    path: 'voluntary',
    canActivate: [AuthVoluntaryGuard],
    loadChildren: () =>
      import('./_metronic/layout-voluntary/layout-voluntary.module').then(
        (m) => m.LayoutVoluntaryModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },
  {
    path: 'voluntario',
    canActivate: [AuthVoluntaryGuard],
    loadChildren: () =>
      import('./_metronic/layout-voluntary/layout-voluntary.module').then(
        (m) => m.LayoutVoluntaryModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },

  {
    path: 'regional',
    canActivate: [AuthRegionalGuard],
    loadChildren: () =>
      import('./_metronic/layout-regional/layout-regional.module').then(
        (m) => m.LayoutRegionalModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },
  {
    path: 'regionale',
    canActivate: [AuthRegionalGuard],
    loadChildren: () =>
      import('./_metronic/layout-regional/layout-regional.module').then(
        (m) => m.LayoutRegionalModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },

  {
    path: 'cooperative',
    canActivate: [AuthCooperativeGuard],
    loadChildren: () =>
      import('./_metronic/layout-cooperative/layout-cooperative.module').then(
        (m) => m.LayoutCooperativeModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },
  {
    path: 'cooperativa',
    canActivate: [AuthCooperativeGuard],
    loadChildren: () =>
      import('./_metronic/layout-cooperative/layout-cooperative.module').then(
        (m) => m.LayoutCooperativeModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },

  {
    path: 'admin',
    canActivate: [AuthAdminGuard],
    loadChildren: () =>
      import('./_metronic/layout-admin/layout-admin.module').then(
        (m) => m.LayoutAdminModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },
  {
    path: 'v4/admin',
    canActivate: [AuthAdminGuard],
    loadChildren: () =>
      import('./_metronic/layout-admin/layout-admin.module').then(
        (m) => m.LayoutAdminModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },

  // PAGES PUBLIC
  {
    path: '',
    loadChildren: () =>
      import('./modules/pages-public/pages-public.module').then(
        (m) => m.PagesPublicModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },

  // AUTHS
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },
  {
    path: 'auth-admin',
    loadChildren: () =>
      import('./modules/auth-admin/auth-admin.module').then(
        (m) => m.AuthAdminModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },
  {
    path: 'auth-voluntary',
    loadChildren: () =>
      import('./modules/auth-voluntary/auth-voluntary.module').then(
        (m) => m.AuthVoluntaryModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },
  {
    path: 'auth-regional',
    loadChildren: () =>
      import('./modules/auth-regional/auth-regional.module').then(
        (m) => m.AuthRegionalModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },
  {
    path: 'auth-cooperative',
    loadChildren: () =>
      import('./modules/auth-cooperative/auth-cooperative.module').then(
        (m) => m.AuthCooperativeModule
      ),
    resolve: {
      company: AppCompanyResolverGuard,
    },
  },

  // OTHERS
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  //{ path: '**', redirectTo: 'error/404' },
  { path: '**', redirectTo: 'admin/access/dashboard' },
];

export const routes: Routes = environment.maintenance
  ? [{ path: '**', component: MaintenanceComponent }]
  : applicationRoutes;

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
